import {getSingleInputByNameV3} from "../../../helpers/forms/formInputsHelpers";
import {loading, stopLoading} from "../../../helpers/loading";
import Axios from "axios";
import createElement from "../../../helpers/createElement";

class NotesDisplay {
	/** @var {HTMLElement} */
	container


	constructor(container, autoScroll = true) {
		this.container = container;

		if (autoScroll) {
			// Scroll container to bottom
			this.container.scrollTop = this.container.scrollHeight + 100;

			setTimeout(() => {
				// And wait a bit before doing it again in case something is
				// preventing it from working
				this.container.scrollTop = this.container.scrollHeight + 100;
			}, 512)
		}
	}

	update(withLoadingOverlay = true) {
		const refreshRoute = getSingleInputByNameV3(this.container, 'refresh_url');

		if (withLoadingOverlay) {
			loading(this.container);
		}

		Axios.post(refreshRoute)
			.then(response => {
				// Replace HTML
				const newContainer = createElement(response.data.display);
				this.container.replaceWith(newContainer);

				// Save in memory
				this.container = newContainer;

				// Scroll to bottom
				this.container.scrollTop = this.container.scrollHeight + 100;
			})
			.finally(() => {
				if (withLoadingOverlay) {
					stopLoading(this.container);
				}
			})
	}
}

export {NotesDisplay}

